import { render } from "./PlanB.vue?vue&type=template&id=46e24628"
import script from "./PlanB.vue?vue&type=script&lang=js"
export * from "./PlanB.vue?vue&type=script&lang=js"

import "./PlanB.vue?vue&type=style&index=0&id=46e24628&lang=scss&scope=true"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__